import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  OutBoxMessagesService,
  SendLimitsService,
} from 'src/app/core/api/services';
import {
  CustomResultOfPaginatedListOfGetSendLimitsWithPaginationDto,
  GetSendLimitsWithPaginationDto,
  PaginatedListOfGetSendLimitsWithPaginationDto,
} from '../../../core/api/models';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base';
import { SendLimitsFormComponent } from './send-limits-form/send-limits-form.component';

@Component({
    selector: 'app-send-limits',
    templateUrl: './send-limits.component.html',
    imports: [
        BaseIndexModule,
        SendLimitsFormComponent,
    ]
})
export class SendLimitsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.sendLimits;
  protected currentService = inject(SendLimitsService);
  /* Binding service endpoints */
  paginationApiMethodName: string =
    this.currentService.sendLimitsGetSendLimitWithPagination.name;
  createGetApiMethodName: string =
    this.currentService.sendLimitsCreateGet.name;
  auditApiMethodName: string =
    this.currentService.sendLimitsGetSendLimitAudits.name;
  /* Binding service endpoints */


  modelWithPagination$: Observable<PaginatedListOfGetSendLimitsWithPaginationDto>;
  items$: Observable<Array<GetSendLimitsWithPaginationDto>>;
  formPageConfig: FormPageConfig<any> = {};

  //#endregion

  constructor(
    public outBoxMessagesService: OutBoxMessagesService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: `${this.tableVocabs}privateNumberNumber`,
        name: 'privateNumberNumber',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: `${this.tableVocabs}dailySendLimit`,
        name: 'dailySendLimit',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}monthlySendLimit`,
        name: 'monthlySendLimit',
        hasSearch: true,
        type: 'number',
      },
    ];
  }

  //#region initial methods

  setDefaultTableSort() {
    this.sortObject.push({ columnName: 'dailySendLimit', sort: 1 });
  }

  //#endregion

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .sendLimitsUpdateGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .sendLimitsDelete({ body: { id: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }
  //#endregion
}
